/* Explicit, device-local favorites. Maximum 24 handles; 12 cards per batch; 3 concurrent requests.
   No background catalog fetching, third-party tracking, customer records, or purchase files. */
(() => {
  const dialog = document.getElementById('SJFavorites');
  if (!dialog || !dialog.showModal) return;
  const key = 'sj-studio:saved:v1';
  const valid = h => typeof h === 'string' && /^[\p{L}\p{N}][\p{L}\p{N}\p{M}\p{S}_-]{0,254}$/u.test(h);
  let saved = [], persistent = true, limit = 12, controller;
  try { const value = JSON.parse(localStorage.getItem(key) || '[]'); saved = Array.isArray(value) ? [...new Set(value.filter(valid))].slice(0, 24) : []; } catch { persistent = false; }
  const status = document.getElementById('SJSaveStatus');
  const notify = message => { status.textContent = message; };
  const broadcast = () => document.dispatchEvent(new CustomEvent('sj:savedchange'));
  const persist = () => { try { localStorage.setItem(key, JSON.stringify(saved)); persistent = true; } catch { persistent = false; notify(dialog.dataset.temporary); } broadcast(); };
  class SaveButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button || !valid(this.dataset.handle)) return;
      this.button.hidden = false;
      this.update = () => this.button.setAttribute('aria-pressed', String(saved.includes(this.dataset.handle)));
      this.click = () => {
        const handle = this.dataset.handle;
        if (saved.includes(handle)) saved = saved.filter(h => h !== handle);
        else if (saved.length < 24) saved.push(handle);
        else { notify(dialog.dataset.capacity); return; }
        persist();
      };
      this.button.addEventListener('click', this.click); document.addEventListener('sj:savedchange', this.update); this.update();
    }
    disconnectedCallback() { this.button?.removeEventListener('click', this.click); document.removeEventListener('sj:savedchange', this.update); }
  }
  if (!customElements.get('sj-save-button')) customElements.define('sj-save-button', SaveButton);
  const node = (tag, text, className) => { const n = document.createElement(tag); if (text) n.textContent = text; if (className) n.className = className; return n; };
  const root = dialog.dataset.root.endsWith('/') ? dialog.dataset.root : dialog.dataset.root + '/';
  const list = dialog.querySelector('[data-sj-favorites-list]');
  const message = dialog.querySelector('[data-sj-favorites-status]');
  const more = dialog.querySelector('[data-sj-more]');
  const money = value => new Intl.NumberFormat(dialog.dataset.locale || 'en', { style: 'currency', currency: dialog.dataset.currency || 'USD' }).format(value / 100);
  async function render() {
    controller?.abort(); controller = new AbortController(); const signal = controller.signal;
    const handles = saved.slice(0, limit); list.replaceChildren(); message.textContent = handles.length ? dialog.dataset.loading : dialog.dataset.empty; more.hidden = saved.length <= limit;
    const slots = handles.map(() => { const slot = node('article', '', 'sj-favorite'); list.append(slot); return slot; });
    let index = 0;
    const worker = async () => {
      while (index < handles.length && !signal.aborted) {
        const current = index++, handle = handles[current], slot = slots[current];
        const url = root + 'products/' + encodeURIComponent(handle);
        try {
          const response = await fetch(url + '.js', { signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(String(response.status));
          const product = await response.json(); if (signal.aborted) return;
          const link = node('a'); link.href = url;
          if (product.featured_image) {
            const src = new URL(product.featured_image, location.origin);
            if (src.protocol === 'https:' || src.origin === location.origin) {
              src.searchParams.set('width', '480'); const img = node('img'); img.src = src.href; img.alt = product.title; img.width = 480; img.height = 480; img.loading = 'lazy'; link.append(img);
            }
          }
          link.append(node('h3', product.title));
          const price = Number(product.price); if (Number.isFinite(price)) link.append(node('p', (product.price_varies ? dialog.dataset.from + ' ' : '') + money(price)));
          link.append(node('span', dialog.dataset.view + ' ↗', 'sj-text-link')); slot.append(link);
        } catch (error) { if (signal.aborted) return; slot.append(node('p', dialog.dataset.unavailable)); }
        const remove = node('button', dialog.dataset.remove, 'sj-text-link'); remove.type = 'button';
        remove.addEventListener('click', () => { saved = saved.filter(h => h !== handle); persist(); render().then(() => dialog.querySelector('[data-sj-close]').focus()); }); slot.append(remove);
      }
    };
    await Promise.all([worker(), worker(), worker()]);
    if (!signal.aborted) message.textContent = handles.length ? (persistent ? '' : dialog.dataset.temporary) : dialog.dataset.empty;
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-sj-open-favorites]')) { limit = 12; dialog.showModal(); render(); }
  });
  document.querySelectorAll('[data-sj-open-favorites]').forEach(button => { button.hidden = false; });
  dialog.querySelector('[data-sj-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => controller?.abort());
  dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
  more.addEventListener('click', () => { limit = 24; render(); });
})();
